export interface ModelPeriodDatesPayload {
  id?: number;
  modelDetailedResult?: number;
  fromDate?: string;
  toDate?: string;
  amountRental?: number;
  comments?: string;
}

function toNumber(value: unknown): number | undefined {
  if (value === null || value === undefined || value === '') {
    return undefined;
  }
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : undefined;
}

function toStringValue(value: unknown): string | undefined {
  if (value === null || value === undefined) {
    return undefined;
  }
  const text = String(value).trim();
  return text.length > 0 ? text : undefined;
}

function extractModelDetailedResultId(input: any): number | undefined {
  const direct = toNumber(input?.modelDetailedResult);
  if (direct !== undefined) {
    return direct;
  }
  return toNumber(input?.modelDetailedResult?.id);
}

export function buildModelPeriodDatesPayload(input: any): ModelPeriodDatesPayload {
  const payload: ModelPeriodDatesPayload = {};

  const id = toNumber(input?.id);
  if (id !== undefined) payload.id = id;

  const modelDetailedResult = extractModelDetailedResultId(input);
  if (modelDetailedResult !== undefined) payload.modelDetailedResult = modelDetailedResult;

  const fromDate = toStringValue(input?.fromDate);
  if (fromDate !== undefined) payload.fromDate = fromDate;

  const toDate = toStringValue(input?.toDate);
  if (toDate !== undefined) payload.toDate = toDate;

  const amountRental = toNumber(input?.amountRental);
  if (amountRental !== undefined) payload.amountRental = amountRental;

  const comments = toStringValue(input?.comments);
  if (comments !== undefined) payload.comments = comments;

  return payload;
}
